import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3570e3e6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "auth-page"
};
const _hoisted_2 = {
  key: 0,
  class: "auth-status",
  style: {
    "width": "50%"
  }
};
const _hoisted_3 = ["src"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "已认证", -1));

const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交认证 ");

const _hoisted_6 = {
  key: 0,
  class: "auth-status auth-page"
};
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "您的认证信息已提交成功，工作人员将在七个工作日内进行审核，请您耐心等待！", -1));

const _hoisted_9 = {
  key: 1,
  class: "auth-status auth-page"
};
const _hoisted_10 = ["src"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "认证失败", -1));

const _hoisted_12 = {
  class: "tip error"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("重新认证");

import { reactive, watch, ref, computed, onBeforeUnmount } from 'vue';
import { ElMessage } from 'element-plus';
import BaseForm from '@/components/BaseForm.vue';
import usePersonalCenterStore from "@/stores/modules/personalCenter";
import { certificationTypeMap, certificationTypeTableMap } from '@/utils/staticData';
import { enterpriseAuthenticationForm, pilotCertificationForm, personalCertificateFormRule, enterpriseAuthenticationFormRule, pilotCertificationFormRule } from '@/utils/formSetting.js';
export default {
  __name: 'authPage',
  props: {
    componentParams: {
      type: Object,
      default: () => {}
    }
  },

  setup(__props) {
    const props = __props;
    const usePersonalCenter = usePersonalCenterStore();
    let formData = reactive({
      baseForm: enterpriseAuthenticationForm,
      formRule: enterpriseAuthenticationFormRule
    });
    let form = ref(null);
    let pageType = ref('');
    let authStep = ref(''); // 当前认证步骤 reAuth：重新认证; 
    // 未认证:unauthorized 
    // 认证成功：authorizedSuccess 
    // 认证失败：authorizedFailure 
    // 认证中：authenticating

    let enterpriseCertificateStatus = computed(() => usePersonalCenter?.userInformation?.authenticatedStatus);
    let politCertificateStatus = computed(() => usePersonalCenter?.userInformation?.flyAuthenticatedStatus);
    let authType = computed(() => {
      if (pageType.value === 'enterprise') {
        return enterpriseCertificateStatus.value; // 企业认证
      } else {
        return politCertificateStatus.value; // 飞行员认证
      }
    });
    let certificationData = ref(null); // 认证的数据内容

    watch(() => props.componentParams.pageType, async newVal => {
      pageType.value = newVal;
      formData.formRule = null;
      formData.baseForm = null;
      authStep.value = '';

      if (pageType.value === 'enterprise') {
        enterpriseCertificateStatus.value !== 'authorizedSuccess' && (formData.formRule = enterpriseAuthenticationFormRule);
        formData.baseForm = enterpriseAuthenticationForm;
        authType.value = enterpriseCertificateStatus.value;
      } else {
        politCertificateStatus.value !== 'authorizedSuccess' && (formData.formRule = pilotCertificationFormRule);
        formData.baseForm = pilotCertificationForm;
        authType.value = politCertificateStatus.value;
      }

      if (authType.value === 'authorizedSuccess') {
        certificationData.value = await usePersonalCenter.getCertificationDataById(newVal);
        setFormDefaultData();
      } else if (authType.value === 'authorizedFailure') {
        certificationData.value = await usePersonalCenter.getCertificationDataById(newVal);
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      enterpriseAuthenticationForm.forEach(item => {
        if (item.type === 'upload') {
          item.defaultVal = [];
        } else {
          item.defaultVal = undefined;
        }

        item.disabled = false;
      });
      pilotCertificationForm.forEach(item => {
        if (item.type === 'upload') {
          item.defaultVal = [];
        } else {
          item.defaultVal = undefined;
        }

        item.defaultVal = undefined;
      });
    }); // 认证成功时，填充表单的默认数据

    function setFormDefaultData() {
      formData.baseForm.forEach(item => {
        item.defaultVal = certificationData.value[item.prop];

        if (item.prop === 'classify') {
          item.defaultVal = certificationTypeTableMap[item.defaultVal];
        } else if (item.prop === 'fileUrl') {
          item.defaultVal = item?.defaultVal ? [{
            url: item.defaultVal
          }] : undefined;
        }

        item.disabled = true;
      });
      form.value;
    } // 区分个人认证/企业认证的表单规则


    watch(() => form?.value?.filterForm?.classify, newVal => {
      if (newVal === '个人认证' && authType.value !== 'authorizedSuccess') {
        formData.formRule = personalCertificateFormRule;
      } else if (newVal === '企业认证' && authType.value !== 'authorizedSuccess') {
        formData.formRule = enterpriseAuthenticationFormRule;
      }
    }); // 提交数据前对参数进行处理

    function processFromData() {
      let params = JSON.parse(JSON.stringify(form.value.filterForm));
      params?.classify && (params.classify = certificationTypeMap[params.classify]);
      authStep.value === 'reAuth' && (params.id = certificationData.value.id);
      return params;
    }

    async function handleSubmit() {
      let params = processFromData();
      form.value.form.validate(async (valid, fields) => {
        if (valid) {
          let res = await usePersonalCenter.submitCertification(props.componentParams.pageType, params);

          if (res.code === 200) {
            ElMessage({
              type: 'success',
              message: '成功提交审核数据'
            });
            authStep.value = '';
          } else {
            ElMessage({
              type: 'error',
              message: res.message
            });
          }
        }
      });
    } // 认证失败后重新认证的事件方法


    async function handleReAuthentication() {
      formData.formRule = null;
      formData.baseForm = null;

      if (pageType.value === 'enterprise') {
        formData.formRule = enterpriseAuthenticationFormRule;
        formData.baseForm = enterpriseAuthenticationForm;
        authType.value = enterpriseCertificateStatus.value;
      } else {
        formData.formRule = pilotCertificationFormRule;
        formData.baseForm = pilotCertificationForm;
        authType.value = politCertificateStatus.value;
      }

      authStep.value = 'reAuth';
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_unref(authType) === 'authorizedSuccess' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_unref(authType) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: require(`@/assets/img/certification/certification-${_unref(authType)}.png`)
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _hoisted_4])) : _createCommentVNode("", true), _unref(authType) === 'unauthorized' || _unref(authType) === 'authorizedSuccess' || _unref(authStep) === 'reAuth' ? (_openBlock(), _createBlock(BaseForm, {
        key: 1,
        ref_key: "form",
        ref: form,
        formSet: _unref(formData).baseForm,
        formRule: _unref(formData).formRule
      }, null, 8, ["formSet", "formRule"])) : _createCommentVNode("", true), _unref(authType) === 'unauthorized' || _unref(authStep) === 'reAuth' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })) : _createCommentVNode("", true)]), _unref(authType) === 'authenticating' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
        src: require(`@/assets/img/certification/certification-${_unref(authType)}.png`)
      }, null, 8, _hoisted_7), _hoisted_8])) : _unref(authType) === 'authorizedFailure' && _unref(authStep) !== 'reAuth' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("img", {
        src: require(`@/assets/img/certification/certification-${_unref(authType)}.png`)
      }, null, 8, _hoisted_10), _hoisted_11, _createElementVNode("div", _hoisted_12, " 认证失败原因：" + _toDisplayString(_unref(certificationData)?.mark), 1), _createVNode(_component_el_button, {
        round: "",
        class: "againBtn",
        type: "primary",
        onClick: handleReAuthentication
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      })])) : _createCommentVNode("", true)], 64);
    };
  }

};